export enum TimeslotStatus {
    Unknown = 0,
    Booked = 1,
    BookedFromPortal = 2,
    Confirmed = 3
}
